import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/TiktokUserHashtags.graphql';
import { Query, QuerytiktokUserHashtagsArgs } from '../../__generated__/globalTypes';

export const useTiktokUserHashtagsQuery = (options?: QueryHookOptions<Query, QuerytiktokUserHashtagsArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerytiktokUserHashtagsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useTiktokUserHashtagsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerytiktokUserHashtagsArgs>
): QueryResult<Query, QuerytiktokUserHashtagsArgs> & {
  getTiktokUserHashtags: LazyQueryExecFunction<Query, QuerytiktokUserHashtagsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getTiktokUserHashtags, result] = useLazyQuery<Query, QuerytiktokUserHashtagsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getTiktokUserHashtags, ...result };
};

export const useTiktokUserHashtagsPromiseQuery = () => {
  const client = useApolloClient();

  const getTiktokUserHashtags = useCallback(
    (options?: Omit<QueryOptions<QuerytiktokUserHashtagsArgs, Query>, 'query'>) =>
      client.query<Query, QuerytiktokUserHashtagsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getTiktokUserHashtags };
};
// Suspense Query Hooks
export const useTiktokUserHashtagsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerytiktokUserHashtagsArgs>
) => {
  const result = useSuspenseQuery<Query, QuerytiktokUserHashtagsArgs>(QUERY, {
    ...options
  });

  return result;
};
